<div class="vue-table-container" [class.loading]="loading">
  <ng-content></ng-content>
  <div class="spinner-container" [ngStyle]="spinnerContainerStyle" *ngIf="loading">
    <mat-spinner diameter="32"></mat-spinner>
  </div>
</div>
